import emailsService from "@/services/emailsService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      await emailsService.create(formData);
      dispatch(
        "common/showSuccess",
        "E-Mail wurde erfolgreich gespeichert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "E-Mail konnte nicht gespeichert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async resend({ dispatch }, formData) {
    try {
      await emailsService.resend(formData);
      dispatch(
        "common/showSuccess",
        "E-Mail wurde erfolgreich gesendet.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "E-Mail konnte nicht gesendet werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async sendSimple({ dispatch }, formData) {
    try {
      await emailsService.sendSimple(formData);
      dispatch(
        "common/showSuccess",
        "E-Mail wurde erfolgreich gesendet.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "E-Mail konnte nicht gesendet werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }, formData) {
    commit("setAll", []);
    try {
      const res = await emailsService.findAll(formData);
      commit("setAll", res.data);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "E-Mails für diese Buchung konnten nicht geladen werden." + error,
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async getAttachement({ dispatch }, formData) {
    try {
      const res = await emailsService.getAttachement(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Anhang-Datei für diese Buchung konnte nicht geladen werden." + error,
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await emailsService.delete({ id });
      dispatch(
        "common/showSuccess",
        "E-Mail wurde erfolgreich gelöscht.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "E-Mail für diese Buchung konnte nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
